export type { ArticlePageProps } from "./article-page";
export { ArticlePage } from "./article-page";
